<template lang="pug">
  v-row.auth-fill-height(justify="center" align="center")
    v-col(cols="12" lg="6")
      sign-in-form(
        :redirect="$route.query.redirect"
      )

</template>

<script>
import SignInForm from '@/modules/Auth/components/SignInForm.vue';

export default {
  components: { SignInForm },
};
</script>
